import React from "react";
import { useI18n } from "@/i18n";

export function LangSwitcher() {
  const { lang, setLang } = useI18n();
  return (
    <div className="flex items-center gap-2 text-xs tracking-[0.2em] uppercase" data-testid="lang-switcher">
      <button
        onClick={() => setLang("fr")}
        className={`px-1 ${lang === "fr" ? "text-[#D4AF37]" : "text-[#0A1128]/60 hover:text-[#0A1128]"}`}
        data-testid="lang-fr"
      >
        FR
      </button>
      <span className="text-[#0A1128]/30">/</span>
      <button
        onClick={() => setLang("en")}
        className={`px-1 ${lang === "en" ? "text-[#D4AF37]" : "text-[#0A1128]/60 hover:text-[#0A1128]"}`}
        data-testid="lang-en"
      >
        EN
      </button>
    </div>
  );
}
